import React from 'react';
import { TabContainer, Tab, TabItem, TabItemWrapper } from './css';

const TabSelection = ({ selectedTab, setSelectedTab }) => {
  return (
    <TabContainer>
      <Tab>
        <TabItemWrapper active={selectedTab === 'MANAGED_IT_SERVICE'}>
          <TabItem
            active={selectedTab === 'MANAGED_IT_SERVICE'}
            onClick={() => setSelectedTab('MANAGED_IT_SERVICE')}
          >
            Managed IT Services
          </TabItem>
        </TabItemWrapper>
        <TabItemWrapper active={selectedTab === 'MICROSOFT_LICENSING'}>
          <TabItem
            active={selectedTab === 'MICROSOFT_LICENSING'}
            onClick={() => setSelectedTab('MICROSOFT_LICENSING')}
          >
            Microsoft Licensing
          </TabItem>
        </TabItemWrapper>
      </Tab>
    </TabContainer>
  );
};

export default TabSelection;
